exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[data-v-5ef7297f] .dialog-footer {\n  margin-left: 0;\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/sunpay-system-manager/src/components/device/editor.vue"],"names":[],"mappings":";AACA;EACE,eAAe;CAChB","file":"editor.vue","sourcesContent":["\n[data-v-5ef7297f] .dialog-footer {\n  margin-left: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ef7297f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/device/editor.vue
// module id = X6Du
// module chunks = 8